import './App.css';
import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import BlankLayout from './layouts/BlankLayout';
import MainLayout from './layouts/MainLayout';
import WebLayout from './layouts/WebLayout';
import ProtectedRoute from './ProtectedRoute';
import Default from './pages/Default';
import Register from './pages/Register';
import Login from './pages/Login';
import Home from './pages/Home';
import Logout from './pages/Logout';
import MyProfile from './pages/MyProfile';
import MyListings from './pages/MyListings';
import MyCalendar from './pages/MyCalendar';
import Plans from './pages/Plans';
import MySubscription from './pages/MySubscription';
import CreateListing from './pages/CreateListing';
import CalendarView from './pages/CalendarView';
import ProfileInformation from './profile/ProfileInformation';
import Overview from './modules/create-listing/Overview';
import Messages from './pages/Messages';
import Chat from './pages/Chat';
import Notifications from './pages/Notifications';
import BookingDetails from './pages/BookingDetails';
import Index from './modules/hotel/Index';
import Spotlight from './profile/Spotlight';
import Checkin from './pages/Checkin';
import Checkout from './pages/Checkout';
import GuestDetails from './pages/GuestDetails';
import Earnings from './pages/Earnings';
import TaggingRequest from './pages/TaggingRequest';
import TaggingDetails from './pages/TaggingDetails';
import AddVideo from './pages/AddVideo';
import Videos from './pages/Videos';
import Ratings from './pages/Ratings';
import AccelerateProgram from './pages/AccelerateProgram';
import AccelerateListing from './pages/AccelerateListing';
import CoHost from './pages/CoHost';
import ManageCoHost from './pages/ManageCoHost';
import CreateCoHost from './pages/CreateCoHost';
import UpdateCoHost from './pages/UpdateCoHost';
import Subscription from './pages/Subscription';
import RenewalHistory from './pages/RenewalHistory';
import Vibes from './pages/Vibes';
import Payment from './pages/Payment';
import WebPayment from './pages/WebPayment';
import WebEarning from './pages/WebEarning';
import WebRatings from './pages/WebRatings';
import WebCheckin from './pages/WebCheckin';
import WebCheckout from './pages/WebCheckout';
import DocumentViewer from './pages/DocumentViewer';
import PayoutDetails from './pages/PayoutDetails';
import PendingDocumentList from './pages/PendingDocumentList';
import PersonalInformation from './modules/co-host/PersonalInformation';
import SpotlightInformation from './modules/co-host/SpotlightInformation';
import EarningDetails from './pages/EarningDetails';
import ListingReview from './pages/ListingReview';
import SettlementDetails from './pages/SettlementDetails';
import Reports from './pages/Reports';
import ListingReports from './pages/ListingReports';
import PayoutIndex from './modules/payout/Index';
import AddPayoutOption from './modules/payout/AddPayoutOption';
import WebSpotlightInformation from './modules/co-host/WebSpotlightInformaton';
import WebPersonalInformation from './modules/co-host/WebPersonalInformation';
import GuestProfile from './pages/GuestProfile';
import Posts from './articles/Posts';
import Menu from './components/Menu';
import WebProfileInformation from './profile/WebProfileInformation';
import ListingReportDetails from './pages/ListingReportDetails';
import WebSpotlight from './profile/WebSpotlight';
import MyRatings from './pages/MyRatings';
import ListingDocumentVerification from './pages/ListingDocumentVerification';
import ManageDiscounts from './pages/ManageDiscounts';
import SmartDiscounts from './pages/SmartDiscounts';
import AccelerateHistory from './pages/AccelerateHistory';
import HostingHomes from './resources/HostingHomes';
import Details from './resources/Details';
import WebHostingHomes from './resources/WebHostingHomes';
import NotificationSetting from './pages/NotificationSetting';

function AppWrapper() {
  return (
    <Router>
      <App />
    </Router>
  );
}

function App() {
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const checkScreenSize = () => {
      const smallScreen = window.innerWidth < 1200;
      setIsSmallScreen(smallScreen);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    return () => {
      window.removeEventListener('resize', checkScreenSize);
    };
  }, []);

  const isWebPaymentRoute = location.pathname.startsWith('/web-payment/');
  const isWebEarningRoute = location.pathname.startsWith('/web-earning/');
  const isWebRatingsRoute = location.pathname.startsWith('/web-ratings/');
  const isWebCheckinRoute = location.pathname.startsWith('/web-checkin/');
  const isWebCheckoutRoute = location.pathname.startsWith('/web-checkout/');
  const isCoHostPInfo = location.pathname.startsWith('/co-host/web-personal-information/');
  const isCoHostSInfo = location.pathname.startsWith('/co-host/web-spotlight-information/');
  const isHostPInfo = location.pathname.startsWith('/profile/web-profile-information/');
  const isHostSInfo = location.pathname.startsWith('/profile/web-spotlight/');
  const isWebHostingResource = location.pathname.startsWith('/resources/web-hosting-homes');
  if (isSmallScreen && !isWebPaymentRoute && !isWebEarningRoute && !isWebRatingsRoute && !isWebCheckinRoute && !isWebCheckoutRoute && !isCoHostPInfo && !isCoHostSInfo && !isHostPInfo && !isHostSInfo && !isWebHostingResource) {
    return (
      <div className="small-screen-message">
        <a href="/">
          <img src={'/assets/img/host_mobile_view.webp'} alt="wire stay host" className="img-fluid w-100" />
        </a>
      </div>
    );
  }

  return (
    <>
       <Routes>
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <BlankLayout>
                <Default />
              </BlankLayout>
            </ProtectedRoute>
          }
         />
         <Route 
          path="/login" 
          element={
            <BlankLayout>
              <Login />
            </BlankLayout>
          } 
         />
         <Route 
          path="/register" 
          element={
            <BlankLayout>
              <Register />
            </BlankLayout>
          } 
         />
         <Route
          path="/menu"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Menu />
              </MainLayout>
            </ProtectedRoute>
          }
         />
         <Route
          path="/home"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Home />
              </MainLayout>
            </ProtectedRoute>
          }
         />
         <Route
          path="/booking-details/:bookingId/:categoryId"
          element={
            <ProtectedRoute>
              <MainLayout>
                <BookingDetails />
              </MainLayout>
            </ProtectedRoute>
          }
         />
         <Route
          path="/guest-details/:bookingId/:categoryId"
          element={
            <ProtectedRoute>
              <MainLayout>
                <GuestDetails />
              </MainLayout>
            </ProtectedRoute>
          }
         />
         <Route
          path="/guest-profile/:userId"
          element={
            <ProtectedRoute>
              <MainLayout>
                <GuestProfile />
              </MainLayout>
            </ProtectedRoute>
          }
         />
         <Route
          path="/my-profile"
          element={
            <ProtectedRoute>
              <MainLayout>
                <MyProfile />
              </MainLayout>
            </ProtectedRoute>
          }
         />
         <Route
          path="/profile/profile-information"
          element={
            <ProtectedRoute>
              <MainLayout>
                <ProfileInformation />
              </MainLayout>
            </ProtectedRoute>
          }
         />
         <Route
          path="/profile/spotlight"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Spotlight />
              </MainLayout>
            </ProtectedRoute>
          }
         />
         <Route
          path="/my-calendar"
          element={
            <ProtectedRoute>
              <MainLayout>
                <MyCalendar />
              </MainLayout>
            </ProtectedRoute>
          }
         />
         <Route
          path="/calendar-view/:listingId"
          element={
            <ProtectedRoute>
              <MainLayout>
                <CalendarView />
              </MainLayout>
            </ProtectedRoute>
          }
         />
         <Route
          path="/create-listing/overview"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Overview />
              </MainLayout>
            </ProtectedRoute>
          }
         />
         <Route
          path="/create-listing/:listingId"
          element={
            <ProtectedRoute>
              <MainLayout>
                <CreateListing />
              </MainLayout>
            </ProtectedRoute>
          }
         />
         <Route
          path="/my-listings"
          element={
            <ProtectedRoute>
              <MainLayout>
                <MyListings />
              </MainLayout>
            </ProtectedRoute>
          }
         />
         <Route
          path="/plans"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Plans />
              </MainLayout>
            </ProtectedRoute>
          }
         />
         <Route
          path="/my-subscription/"
          element={
            <ProtectedRoute>
              <MainLayout>
                <MySubscription />
              </MainLayout>
            </ProtectedRoute>
          }
         />
         <Route
          path="/messages"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Messages />
              </MainLayout>
            </ProtectedRoute>
          }
         />
         <Route
          path="/chat"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Chat />
              </MainLayout>
            </ProtectedRoute>
          }
         />
         <Route
          path="/notifications"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Notifications />
              </MainLayout>
            </ProtectedRoute>
          }
         />
         <Route
          path="/notification-settings"
          element={
            <ProtectedRoute>
              <MainLayout>
                <NotificationSetting />
              </MainLayout>
            </ProtectedRoute>
          }
         />
         <Route
          path="/earnings"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Earnings />
              </MainLayout>
            </ProtectedRoute>
          }
         />
         <Route
          path="/earning-details"
          element={
            <ProtectedRoute>
              <MainLayout>
                <EarningDetails />
              </MainLayout>
            </ProtectedRoute>
          }
         />
         <Route
          path="/settlement-details"
          element={
            <ProtectedRoute>
              <MainLayout>
                <SettlementDetails />
              </MainLayout>
            </ProtectedRoute>
          }
         />
         <Route
          path="/logout"
          element={
            <ProtectedRoute>
              <Logout />
            </ProtectedRoute>
          }
         />
         <Route
          path="/hotel/index"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Index />
              </MainLayout>
            </ProtectedRoute>
          }
         />
         <Route
          path="/checkin/:bookingId"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Checkin />
              </MainLayout>
            </ProtectedRoute>
          }
         />
         <Route
          path="/checkout/:bookingId"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Checkout />
              </MainLayout>
            </ProtectedRoute>
          }
         />
         <Route
          path="/tagging-request/"
          element={
            <ProtectedRoute>
              <MainLayout>
                <TaggingRequest />
              </MainLayout>
            </ProtectedRoute>
          }
         />
         <Route
          path="/tagging-details/:tagId"
          element={
            <ProtectedRoute>
              <MainLayout>
                <TaggingDetails />
              </MainLayout>
            </ProtectedRoute>
          }
         />
         <Route
          path="/add-video/:listingId"
          element={
            <ProtectedRoute>
              <MainLayout>
                <AddVideo />
              </MainLayout>
            </ProtectedRoute>
          }
         />
         <Route
          path="/videos/:listingId"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Videos />
              </MainLayout>
            </ProtectedRoute>
          }
         />
         <Route
          path="/ratings/:listingId"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Ratings />
              </MainLayout>
            </ProtectedRoute>
          }
         />
         <Route
          path="/accelerate-program/"
          element={
            <ProtectedRoute>
              <MainLayout>
                <AccelerateProgram />
              </MainLayout>
            </ProtectedRoute>
          }
         />
         <Route
          path="/accelerate-listing/:listingId"
          element={
            <ProtectedRoute>
              <MainLayout>
                <AccelerateListing />
              </MainLayout>
            </ProtectedRoute>
          }
         />
         <Route
          path="/accelerate-history/"
          element={
            <ProtectedRoute>
              <MainLayout>
                <AccelerateHistory />
              </MainLayout>
            </ProtectedRoute>
          }
         />
         <Route
          path="/manage-discounts/"
          element={
            <ProtectedRoute>
              <MainLayout>
                <ManageDiscounts />
              </MainLayout>
            </ProtectedRoute>
          }
         />
         <Route
          path="/smart-discounts/:listingId"
          element={
            <ProtectedRoute>
              <MainLayout>
                <SmartDiscounts />
              </MainLayout>
            </ProtectedRoute>
          }
         />
         <Route
          path="/co-host/"
          element={
            <ProtectedRoute>
              <MainLayout>
                <CoHost />
              </MainLayout>
            </ProtectedRoute>
          }
         />
         <Route
          path="/manage-co-host/:listingId"
          element={
            <ProtectedRoute>
              <MainLayout>
                <ManageCoHost />
              </MainLayout>
            </ProtectedRoute>
          }
         />
         <Route
          path="/create-co-host/:listingId"
          element={
            <ProtectedRoute>
              <MainLayout>
                <CreateCoHost />
              </MainLayout>
            </ProtectedRoute>
          }
         />
         <Route
          path="/update-co-host/:listingId/:hostId"
          element={
            <ProtectedRoute>
              <MainLayout>
                <UpdateCoHost />
              </MainLayout>
            </ProtectedRoute>
          }
         />
         <Route
          path="/subscription/"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Subscription />
              </MainLayout>
            </ProtectedRoute>
          }
         />
         <Route
          path="/renewal-history/"
          element={
            <ProtectedRoute>
              <MainLayout>
                <RenewalHistory />
              </MainLayout>
            </ProtectedRoute>
          }
         />
         <Route
          path="/vibes/"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Vibes />
              </MainLayout>
            </ProtectedRoute>
          }
         />
         <Route
          path="/payment/"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Payment />
              </MainLayout>
            </ProtectedRoute>
          }
         />
         <Route
          path="/view-documents/:bookingId"
          element={
            <ProtectedRoute>
              <MainLayout>
                <DocumentViewer />
              </MainLayout>
            </ProtectedRoute>
          }
         />
         <Route
          path="/payout-details/"
          element={
            <ProtectedRoute>
              <MainLayout>
                <PayoutDetails />
              </MainLayout>
            </ProtectedRoute>
          }
         />
         <Route
          path="/pending-document-list/"
          element={
            <ProtectedRoute>
              <MainLayout>
                <PendingDocumentList />
              </MainLayout>
            </ProtectedRoute>
          }
         />
         <Route
          path="/listing-document-verification/"
          element={
            <ProtectedRoute>
              <MainLayout>
                <ListingDocumentVerification />
              </MainLayout>
            </ProtectedRoute>
          }
         />
         <Route
          path="/co-host/personal-information/:id"
          element={
            <ProtectedRoute>
              <MainLayout>
                <PersonalInformation />
              </MainLayout>
            </ProtectedRoute>
          }
         />
         <Route
          path="/co-host/spotlight-information/:id"
          element={
            <ProtectedRoute>
              <MainLayout>
                <SpotlightInformation />
              </MainLayout>
            </ProtectedRoute>
          }
         />
         <Route
          path="/listing-review/"
          element={
            <ProtectedRoute>
              <MainLayout>
                <ListingReview />
              </MainLayout>
            </ProtectedRoute>
          }
         />
         <Route
          path="/reports/"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Reports />
              </MainLayout>
            </ProtectedRoute>
          }
         />
         <Route
          path="/listing-reports/"
          element={
            <ProtectedRoute>
              <MainLayout>
                <ListingReports />
              </MainLayout>
            </ProtectedRoute>
          }
         />
         <Route
          path="/listing-report-details/:reportId"
          element={
            <ProtectedRoute>
              <MainLayout>
                <ListingReportDetails />
              </MainLayout>
            </ProtectedRoute>
          }
         />
         <Route
          path="/payouts/"
          element={
            <ProtectedRoute>
              <MainLayout>
                <PayoutIndex />
              </MainLayout>
            </ProtectedRoute>
          }
         />
         <Route
          path="/payouts/add-payout-option"
          element={
            <ProtectedRoute>
              <MainLayout>
                <AddPayoutOption />
              </MainLayout>
            </ProtectedRoute>
          }
         />
         <Route
          path="/articles/post/:slug"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Posts />
              </MainLayout>
            </ProtectedRoute>
          }
         />
         <Route
          path="/my-ratings"
          element={
            <ProtectedRoute>
              <MainLayout>
                <MyRatings />
              </MainLayout>
            </ProtectedRoute>
          }
         />
         <Route
          path="/web-payment/:token"
          element={
            <WebLayout>
              <WebPayment />
            </WebLayout>
          }
         />
         <Route
          path="/web-earning/:token"
          element={
            <WebLayout>
              <WebEarning />
            </WebLayout>
          }
         />
         <Route
          path="/web-ratings/:token/:listingId"
          element={
            <WebLayout>
              <WebRatings />
            </WebLayout>
          }
         />
         <Route
          path="/web-checkin/:token/:bookingId"
          element={
            <WebLayout>
              <WebCheckin />
            </WebLayout>
          }
         />
         <Route
          path="/web-checkout/:token/:bookingId"
          element={
            <WebLayout>
              <WebCheckout />
            </WebLayout>
          }
         />
         <Route
          path="/co-host/web-personal-information/:token/:id"
          element={
            <WebLayout>
              <WebPersonalInformation />
            </WebLayout>
          }
         />
         <Route
          path="/co-host/web-spotlight-information/:token/:id"
          element={
            <WebLayout>
              <WebSpotlightInformation />
            </WebLayout>
          }
         />
         <Route
          path="/profile/web-profile-information/:token"
          element={
            <WebLayout>
              <WebProfileInformation />
            </WebLayout>
          }
         />
         <Route
          path="/profile/web-spotlight/:token"
          element={
            <WebLayout>
              <WebSpotlight />
            </WebLayout>
          }
         />
        <Route
          path="/resources/hosting-homes"
          element={
            <ProtectedRoute>
              <MainLayout>
                <HostingHomes />
              </MainLayout>
            </ProtectedRoute>
          }
         />
         <Route
          path="/resources/details/:slug"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Details />
              </MainLayout>
            </ProtectedRoute>
          }
         />
         <Route
          path="/resources/web-hosting-homes/:token"
          element={
            <WebLayout>
              <WebHostingHomes />
            </WebLayout>
          }
         />

       </Routes>
   </>
  );
}

export default AppWrapper;
